import { render, staticRenderFns } from "./document-upload.vue?vue&type=template&id=545c3605&scoped=true&lang=pug"
import script from "./document-upload.vue?vue&type=script&lang=ts"
export * from "./document-upload.vue?vue&type=script&lang=ts"
import style0 from "./document-upload.vue?vue&type=style&index=0&id=545c3605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c3605",
  null
  
)

export default component.exports